import {Button} from 'antd';
import PropTypes from 'prop-types';
import {useNavigate} from 'react-router-dom';

// import ResetPasswordComponent from '../../../../CommonComponents/ResetPasswordComponent/ResetPasswordComponent';

export const ForgotPasswordScreen = ({setShowForgotPassword}) => {

  const navigate = useNavigate();

  const handleBackToLogin = () => {
    setShowForgotPassword(false);
    navigate('/'); // change path here
  };

  return (
    <div className={'w-full h-full flex justify-center items-center'}>
      <div className={'w-full max-w-md'}>
        <h2 className={'md:text-3xl text-xl md:mb-8 mb-5 text-primary-900 flex font-semibold w-full justify-center items-center font-instrument '}>
          Reset Password
        </h2>

        {/* <ResetPasswordComponent onResetSuccess={handleBackToLogin} /> */}

        <div className={'text-center mt-4'}>
          <Button
            onClick={handleBackToLogin}
            className={'!text-primary-700 border-none hover:underline focus:outline-none'}
          >
            Back to Login
          </Button>
        </div>
      </div>
    </div>
  );
};

ForgotPasswordScreen.propTypes = {
  setShowForgotPassword: PropTypes.func.isRequired,
};

export default ForgotPasswordScreen;
